import { render, staticRenderFns } from "./schoolManagement.vue?vue&type=template&id=2f936fa2&scoped=true&"
import script from "./schoolManagement.vue?vue&type=script&lang=js&"
export * from "./schoolManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f936fa2",
  null
  
)

export default component.exports